import { AIButtonIconGrey as AIButtonIconGreyButton } from '../../AIButton'
import { INLINE_BUTTON_SIZES } from '../Buttons'
import { Container } from '../Container'

import PlusIcon from '../../../icons/plus.svg'

export function AIButtonIconGrey() {
  return (
    <>
      <Container label='AI Button, icon grey, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <AIButtonIconGreyButton Icon={PlusIcon} height={size} key={size} />
        ))}
      </Container>
      <Container label='AI Button, icon grey, disabled, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <AIButtonIconGreyButton
            disabled
            Icon={PlusIcon}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, icon grey, with loader, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <AIButtonIconGreyButton
            isLoading
            Icon={PlusIcon}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, icon grey, with skeleton, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <AIButtonIconGreyButton
            isSkeleton
            Icon={PlusIcon}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
